<template>
  <v-card tile height="100%" width="97%" class="font_dims pb-2" id="instrVid">
    <v-row class="pl-3  mb-0" style="height:20%">
      <v-col cols="6" class="pb-0 mb-0">
        <h3 class="pt-3 pl-3">{{ $t("settingsPage.instVids.header") }}</h3>
      </v-col>
      <v-col cols="6"> </v-col>
    </v-row>
    <v-row class="pl-3  mb-0">
      <v-col cols="2">
        <v-img style="border-style: solid; border-width: 1px; border-color: #F0F2F4;" class="ml-3" :src="ytImg"> </v-img>
      </v-col>
      <v-col cols="9">
        <v-row style=" height:60% ; width:100%" align="end">
          <span style="font-weight:bold">
            {{ $t("settingsPage.instVids.vid1Title") }}
          </span>
        </v-row>
        <v-row style="height:40% ;width:100%" align="center">
          <a
            href="https://www.youtube.com/watch?v=OXfKnRDVET4"
            target="_blank"
            style="text-decoration:underline; color:#323F4F"
            >{{ $t("settingsPage.instVids.link") }}</a
          >
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="pl-3  mt-0">
      <v-col cols="2">
        <v-img style="border-style: solid; border-width: 1px; border-color: #F0F2F4;" class="ml-3" :src="ytsmsImg"> </v-img>
      </v-col>
      <v-col cols="9">
        <v-row style=" height:60% ; width:100%" align="end">
          <span style="font-weight:bold">
            {{ $t("settingsPage.instVids.vid2Title") }}
          </span>
        </v-row>
        <v-row style="height:40% ;width:100%" align="center">
          <a
            href="https://www.youtube.com/watch?v=1yhnt_hHoc8"
            target="_blank"
            style="text-decoration:underline; color:#323F4F"
            >{{ $t("settingsPage.instVids.link") }}</a
          >
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="pl-3  mt-0">
      <v-col cols="2">
        <v-img style="border-style: solid; border-width: 1px; border-color: #F0F2F4;" class="ml-3" :src="ytwaImg"> </v-img>
      </v-col>
      <v-col cols="9">
        <v-row style=" height:60% ; width:100%" align="end">
          <span style="font-weight:bold">
            {{ $t("settingsPage.instVids.vid3Title") }}
          </span>
        </v-row>
        <v-row style="height:40% ;width:100%" align="center">
          <a
            href="https://www.youtube.com/watch?v=77z5kscDD14"
            target="_blank"
            style="text-decoration:underline; color:#323F4F"
            >{{ $t("settingsPage.instVids.link") }}</a
          >
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "InstructionalVids",
  components: {},
  data() {
    return {
      ytImg: require("@/assets/img/mp-cartrecovery-yt-cover.png"),
      ytwaImg: require("@/assets/img/cart-reminder-yt-cover-wa-app.png"),
      ytsmsImg: require("@/assets/img/cart-reminder-yt-cover-sms.png"),
    };
  },
};
</script>

<style scoped>
.v-select >>> label {
  font-size: 100% !important;
}

.v-select {
  height: 70% !important;
}
</style>
